import React from 'react';
import { setCurrentView } from 'core/utils';
import { ReplacementViewStore } from 'modules/order/stores';
import { ReplacementTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new ReplacementViewStore(rootStore, componentProps),
	'replacementViewStore'
)
class Replacement extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <ReplacementTemplate {...this.props} />;
	}
}

export default Replacement;



// WEBPACK FOOTER //
// ./src/modules/order/pages/Replacement.jsx